var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3554 32.3605C43.6571 31.0587 43.6571 28.9482 42.3554 27.6464C41.0536 26.3447 38.9431 26.3447 37.6413 27.6464C36.3396 28.9482 36.3396 31.0587 37.6413 32.3605C38.9431 33.6622 41.0536 33.6622 42.3554 32.3605Z",
    fill: "#FFB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3317 53.3368L43.3317 40.0035C43.3317 38.1625 41.8393 36.6701 39.9984 36.6701C38.1574 36.6701 36.665 38.1625 36.665 40.0035V53.3368C36.665 55.1777 38.1574 56.6701 39.9984 56.6701C41.8393 56.6701 43.3317 55.1777 43.3317 53.3368Z",
    fill: "#FFB300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3317 40.0033C73.3317 58.4127 58.4079 73.3366 39.9984 73.3366C21.5889 73.3366 6.66504 58.4127 6.66504 40.0033C6.66504 21.5938 21.5889 6.66992 39.9984 6.66992C58.4079 6.66992 73.3317 21.5938 73.3317 40.0033ZM66.665 40.0033C66.665 54.7308 54.726 66.6699 39.9984 66.6699C25.2708 66.6699 13.3317 54.7308 13.3317 40.0033C13.3317 25.2757 25.2708 13.3366 39.9984 13.3366C54.726 13.3366 66.665 25.2757 66.665 40.0033Z",
    fill: "#FFB300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.c50954b46e3914b78a6f6f2ae1ae7c92.svg";
export { ForwardRef as ReactComponent };